import Vue from 'vue';
import VueI18n from "vue-i18n";
import ApiService from "@/core/services/api.service";
import localStorageService from "./localStorage.service";

import moment from "moment";

Vue.use(VueI18n);

// set the current language for i18n.
let language = localStorageService.getItem('language')

const locale = language === undefined ? 'tr' : language;

function getTranslations() {
    return ApiService.get(`/api/localization`);
}

function prepareConfig(data) {
    let messages = {};
    let langauges = data.languages;
    localStorage.setItem('languages', JSON.stringify(langauges));
    langauges.forEach(function (currentValue) {
        Vue.set(messages, currentValue.code, data.translations[currentValue.code]);
    });

    let definitions = {};
    if (locale === "tr") {
        definitions = {
            relativeTime : {
                future: "%s sonra",
                past:   "%s önce",
                s:  "%d saniye",
                m:  "%d dakika",
                mm: "%d dakika",
                h:  "%d saat",
                hh: "%d saat",
                d:  "%d gün",
                dd: "%d gün",
                M:  "%d ay",
                MM: "%d ay",
                y:  "%d yıl",
                yy: "%d yıl"
            }
        };
    }

    moment.locale(locale, definitions);

    // Create VueI18n instance with options
    return new VueI18n({
        messages, // set locale messages
        locale: locale
    });
}

export {prepareConfig, getTranslations};
